module.exports = __webpack_public_path__ + "fae0552f4f6646a3a60460a04e29e913.jpg";